<template functional>
  <div>{{ props.item.charges.profit | toCurrency }}</div>
</template>

<script>
export default {
  name: "fltl-profit",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>
